import styled from 'styled-components';
import { Column } from 'components/layout';
import { ReactComponent as _Arrow } from 'styles/icons/arrow.svg';
import { color } from 'styles/settings';
import { withModifiers } from 'utils/styles';
import { brand } from 'styles/settings/color';

export const Container = styled(Column)`
  position: relative;
  width: 48px;
  height: 30px;
  margin-right: 20px;
`;

export const ColorDropdownContainer = styled.div`
  flex: 1;
  position: absolute;
  top: 35px;
  left: -12px;
`;

export const ColorDropdownMenu = styled.div`
  align-items: center;
  background-color: ${color.neutral.white};
  display: flex;
  flex-direction: column;
  padding: 16px 12px;
  padding-bottom: 7px;
  position: relative;
  top: 20px;
  width: 28px;

  :before {
    content: '';
    position: absolute;
    top: -8px;
    transform: rotateX(180deg);
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #fff;
    clear: both;
  }
`;

export const ColorOptionContainer = styled.div`
  width: 28px;
  height: 28px;
  margin-bottom: 9px;
`;

export const SelectedColorContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Arrow = styled(_Arrow)`
  height: 10px;
  width: 10px;
  margin-left: 8px;
  cursor: pointer;
  color: ${color.neutral.plainBlack};
  transition: transform 0.3s linear;

  ${withModifiers('$menuOpened')`
    transform: rotate(180deg);
  `}
`;

export const ColorOption = styled.span`
  display: inline-block;
  background-color: ${color.neutral.white};
  width: 26px;
  height: 26px;
  -moz-border-radius: 16px;
  -webkit-border-radius: 16px;
  border-radius: 16px;

  :hover {
    border: 2px solid ${({ color }) => color};
  }

  :after {
    content: '';
    margin-top: 1px;
    margin-left: 1px;
    height: 24px;
    width: 24px;
    cursor: pointer;
    background-color: ${({ color }) => color};
    border-radius: 50%;
    display: inline-block;
  }
`;

export const ColoredCircle = styled.span`
  height: 24px;
  width: 24px;
  cursor: pointer;
  background-color: ${({ color }) => color};
  border-radius: 50%;
  display: inline-block;
  /* opacity: 0.8; */
  /* transition: opacity 0.5s; */

  /* :hover {
    opacity: 1;
  } */
`;

export const CircleOptionContainer = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const CircleBorder = styled.span`
  border: 1px solid ${({ color }) => color};
  background-color: transparent;
  position: absolute;
  width: 27px;
  height: 27px;
  border-radius: 14.5px;
  opacity: 0.3;
  transition: opacity 0.5s;

  :hover {
    opacity: 1;

    border: 3px solid ${({ color }) => color};
  }
`;
